import React from 'react';

interface UrlFieldProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * A reusable text input field specifically styled for URL inputs.
 *
 * @param value - The current input value
 * @param onChange - Callback function that receives the new value when input changes
 * @param label - Label text displayed above the input
 * @param placeholder - Optional placeholder text for the input
 * @param disabled - Optional flag to disable the input
 * @param className - Optional additional CSS classes
 */
const UrlField: React.FC<UrlFieldProps> = ({
  value,
  onChange,
  label,
  placeholder = 'Enter URL',
  disabled = false,
  className = '',
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={`mb-5 ${className}`}>
      <label className='block text-blue-400 text-sm font-medium mb-2'>{label}</label>
      <input
        type='text'
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className='w-full h-[45px] bg-[#212a40] text-white border border-gray-600 rounded-md px-4 focus:outline-none focus:border-blue-500 disabled:opacity-60 disabled:cursor-not-allowed'
        placeholder={placeholder}
      />
    </div>
  );
};

export default UrlField;
